module.exports = __webpack_public_path__ + "static/media/wechat-qr-image-2.fd342bed.jpeg";